import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const PlayLevel1Product = ({ onWin, onLose }) => {
  const [timeLeft, setTimeLeft] = useState(30);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const imageSequence = [
    { 
      id: 1,
      targetId: "a9b8d412-44ba-33bd-bcfc-0505efabae91",
      url: "https://processed.portal.soot.com/playground-static-assets/product1.png",
    },
    { 
      id: 2,
      targetId: "a9b8d412-44ba-33bd-bcfc-0505efabae92",
      url: "https://processed.portal.soot.com/playground-static-assets/product2.png"
    },
    { 
      id: 3,
      targetId: "a9b8d412-44ba-33bd-bcfc-0505efabae93",
      url: "https://processed.portal.soot.com/playground-static-assets/product3.png"
    }
  ];

  useEffect(() => {
    // Game timer
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          onLose();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    // URL checker
    const urlChecker = setInterval(() => {
      const frame = document.getElementById('sootFrame');
      try {
        const currentUrl = frame?.contentWindow?.location?.href;
        if (currentUrl?.includes(imageSequence[currentImageIndex].targetId)) {
          if (currentImageIndex < imageSequence.length - 1) {
            setCurrentImageIndex(prev => prev + 1);
            setTimeLeft(prev => prev + 30);
          } else {
            onWin(imageSequence);
          }
        }
      } catch (e) {
        // Silently handle cross-origin errors
      }
    }, 500);
    
    return () => {
      clearInterval(timer);
      clearInterval(urlChecker);
    };
  }, [onWin, onLose, currentImageIndex, imageSequence.length]);

  return (
    <div className="h-screen w-full relative">
      <iframe
        id="sootFrame"
        src="https://play.soot.com/applestuff"
        className="w-full h-full border-0"
        allow="same-origin"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals"
      />

      {/* Target images panel */}
      <div className="fixed right-4 top-4 bottom-4 w-36 overflow-y-auto overflow-x-hidden space-y-4 p-2 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-transparent">
        {imageSequence.map((image, index) => {
          if (index > currentImageIndex) return null;
          
          return (
            <motion.div 
              key={image.id}
              className="bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300"
              initial={{ x: 100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
            >
              <div className="aspect-square relative">
                <img
                  src={image.url}
                  alt={`Target ${index + 1}`}
                  className="w-full h-full object-cover transition-all duration-300"
                />
              </div>
              <div className="text-center py-2 bg-black text-white text-sm font-medium">
                {index === currentImageIndex ? 'FIND ME' : 'FOUND'}
              </div>
            </motion.div>
          );
        })}
      </div>

      {/* Timer */}
      <div className="fixed top-4 left-4 px-4 py-2 bg-black bg-opacity-75 rounded-lg">
        <span className={`text-2xl font-bold ${timeLeft <= 10 ? 'text-red-500' : 'text-[#ECFF0F]'}`}>
          {timeLeft}s
        </span>
      </div>

      {/* Win simulation button */}
      <button
        onClick={() => {
          if (currentImageIndex < imageSequence.length - 1) {
            setCurrentImageIndex(prev => prev + 1);
            setTimeLeft(prev => prev + 30);
          } else {
            onWin(imageSequence);
          }
        }}
        className="fixed left-4 bottom-4 w-6 h-6 bg-black hover:bg-gray-700 rounded-full opacity-20 hover:opacity-40 transition-all duration-200"
        title="Simulate win"
      >
        <span className="sr-only">Win</span>
      </button>
    </div>
  );
};

export default PlayLevel1Product;